import { FC, useState, } from "react";

import { useEffectOnce, } from "../../utils/hooks";
import { CameraDeniedView, CameraUnknownErrorView, } from "../../components/features/QrPage";

type QrErrorType = "permissionDenied" | "unknown" | null;

interface Props {
  onSuccess: (code: string) => void;
  onError: (error: unknown) => void;
}

export const QrViewMaxMiniApp: FC<Props> = ({ onSuccess, onError, },) => {
  const [error, setError,] = useState<QrErrorType>(null,);

  useEffectOnce(() => {
    // eslint-disable-next-line
    (async () => {
      try {
        const qrCodeRes = await window.WebApp?.openCodeReader?.();
        onSuccess(qrCodeRes?.value ?? "",);
      } catch (err: unknown) {
        let code: QrErrorType = "unknown";

        // eslint-disable-next-line
        const errorCode = (err as any)?.error?.code;
        if (errorCode === "client.open_code_reader.permission_denied") {
          code = "permissionDenied";
        }

        setError(code,);
        onError(err,);
      }
    })();
  },);

  if (error) {
    return error === "permissionDenied" ? <CameraDeniedView /> : <CameraUnknownErrorView />;
  }

  return null;
};
